export enum GameControlFlowCategory {
  GOTO_LEVEL = 'goto_level'
}
